import React from 'react';
import { Navigate } from 'react-router-dom';
import { PlayerProfilePage } from '../../pages/playerProfile/playerProfilePage';
import { ClinicLayout } from '../clinicLayout';
import { AssessmentPage } from '../pages/assessment/assessment.page';
import { UserPage } from '../../pages/user/user.page';
import { ViewIncidentPage } from '../../pages/viewIncident/viewIncident.page';
import { Notifications } from '../../pages/notifications/notifications';
import { AboutUsPage } from '../../pages/aboutUs/aboutUs.page';
import { ConcussionRecoveryPage } from '../../pages/concussionAdvice/concussionRecovery.page';
import { ConcussionSixRsPage } from '../../pages/concussionAdvice/concussionSixRs.page';
import { ConcussionReturnToLearnPage } from '../../pages/concussionAdvice/concussionReturnToLearn.page';
import { ConcussionReturnToPlayPage } from '../../pages/concussionAdvice/concussionReturnToPlay.page';
import { UserForm } from '../../pages/user/user.form';
import { PlayersPage } from '../../pages/players/playersPage';
import { IncidentsListPage } from '../../pages/incidentsList/incidentsList.page';
import { SummaryPage } from '../pages/assessment/summary/summary.page';
import { AssessmentSummaryPage } from '../../pages/assessmentSummary/assessmentSummary.page';
import { StartAssessment } from '../pages/assessment/startAssessment.smart';
import { AssessmentNormativesPage } from '../pages/assessment/assessmentNormatives.page';
import { PlayersPageQueryService } from '../../pages/players/playersPage.queryParam.service';
import { di } from '../../state/inversify.config';
import { Pages } from '../../state/queryParams/pageQueries.slice';
import { ConneqtPageQueryService } from '../../pages/conneqt/conneqt.queryParam.service';
import { ConneqtPage } from '../../pages/conneqt/conneqtPage';
import { CreateSymptomAssessment } from '../../pages/symptomAssessment/createSymptomAssessment';

const playersPageQueryService = di.get(PlayersPageQueryService);
const conneqtPageQueryService = di.get(ConneqtPageQueryService);

export const clinicRoutes = {
  path: 'clinic',
  element: <ClinicLayout />,
  // lazy={() => import("./a")}
  children: [
    // PLAYERS
    {
      index: true,
      element: <Navigate to={Pages.patients} replace />,
    },
    {
      path: Pages.patients,
      element: <PlayersPage pageQuery={playersPageQueryService} />,
    },
    {
      path: 'player-profile',
      element: <PlayerProfilePage />,
    },
    // ASSESSMENT
    {
      path: 'assessment',
      // index: true,
      element: <AssessmentPage />,
      children: [
        {
          index: true,
          element: <StartAssessment />,
        },
        {
          path: 'assessment-summary',
          element: <SummaryPage />,
        },
        {
          path: 'normatives',
          element: <AssessmentNormativesPage />,
        },
      ],
    },
    {
      path: 'assessment-history',
      element: <AssessmentSummaryPage />,
    },
    // INCIDENT
    {
      path: 'view-incident',
      element: <ViewIncidentPage />,
    },
    {
      path: 'incidents-list',
      element: <IncidentsListPage />,
    },
    // SYMPTOM ASSESSMENT
    {
      path: 'create-symptom-check',
      element: <CreateSymptomAssessment />,
    },

    // CONNEQT
    {
      path: Pages.conneqt,
      element: (
        <ConneqtPage
          pageQueryParam={conneqtPageQueryService}
          showReceived={false}
        />
      ),
    },
    // USER
    {
      path: 'user',
      element: <UserPage />,
      children: [
        {
          path: 'create',
          element: <UserForm mode="create" />,
        },
        {
          path: 'edit',
          element: <UserForm mode="edit" />,
        },
      ],
    },
    {
      path: 'notifications',
      element: <Notifications />,
    },
    {
      path: 'about-us',
      element: <AboutUsPage />,
    },
    {
      path: 'concussion-6rs',
      element: <ConcussionSixRsPage />,
    },
    {
      path: 'concussion-recovery',
      element: <ConcussionRecoveryPage />,
    },
    {
      path: 'concussion-return-to-learn',
      element: <ConcussionReturnToLearnPage />,
    },
    {
      path: 'concussion-return-to-play',
      element: <ConcussionReturnToPlayPage />,
    },
  ],
};
